<script>
    import {_} from 'svelte-i18n';
    import PackListing from '../PackListing.svelte';
    import {onMount} from 'svelte';
    import {goTo} from "../../utils.js";
    import {markSeenFlag} from "../tab-seen.js";

    onMount(() => {
        window.scrollTo(0, 0);
        goTo('/supplies/specialEvents?tab=singleJackFever', true);
        // It is the default Events sub-tab, so it often opens without a click on its
        // button; mark it seen here too so the New ribbon and dots clear either way.
        markSeenFlag('singleJackFeverSeen');
    });
</script>

<PackListing storeSection="singleJackFever" title={$_('SingleJackFeverEventTitle')}/>
